export default {
  white: '#FFFFFF',
  black: '#000000',

  //Grey
  grey: {
    1: '#161616',
    2: '#1C1C1C',
    2.8: '#1C1C1CCC',
    3: '#232323',
    4: '#282828',
    5: '#2E2E2E',
    6: '#343434',
    7: '#3E3E3E',
    8: '#505050',
    9: '#707070',
    10: '#7E7E7E',
    11: '#A0A0A0',
    12: '#EDEDED',
    12.3: '#EDEDED4D',
    12.6: '#EDEDED99',
  },
  //Crimsom
  crimson: {
    1: '#1D1418',
    2: '#27141C',
    3: '#3C1827',
    4: '#481A2D',
    5: '#541B33',
    6: '#641D3B',
    7: '#801D45',
    8: '#AE1955',
    9: '#E93D82',
    10: '#F04F88',
    11: '#F76190',
    12: '#FEECF4',
  },
  //Indigo
  indigo: {
    1: '#131620',
    2: '#15192D',
    3: '#192140',
    4: '#1C274F',
    5: '#1F2C5C',
    6: '#22346E',
    7: '#273E89',
    8: '#2F4EB2',
    9: '#3E63DD',
    10: '#5373E7',
    11: '#849DFF',
    12: '#EEF1FD',
  },
  //Green
  green: {
    1: '#0D1912',
    2: '#0C1F17',
    3: '#0F291E',
    4: '#113123',
    5: '#133929',
    6: '#164430',
    7: '#1B543A',
    8: '#236E4A',
    9: '#30A46C',
    10: '#3CB179',
    11: '#4CC38A',
    12: '#E5FBEB',
  },
  //Red
  red: {
    1: '#1F1315',
    2: '#291415',
    3: '#3C181A',
    4: '#481A1D',
    5: '#541B1F',
    6: '#671E22',
    7: '#822025',
    8: '#AA2429',
    9: '#E5484D',
    10: '#F2555A',
    11: '#FF6369',
    12: '#FEECEE',
  },
  //Yellow
  yellow: {
    1: '#1C1500',
    2: '#221A00',
    3: '#2C2100',
    4: '#352800',
    5: '#3E3000',
    6: '#493C00',
    7: '#594A05',
    8: '#705E00',
    9: '#F5D90A',
    10: '#FFEF5C',
    11: '#F0C000',
    12: '#FFFAD1',
  },
};
